import { Component } from 'react'
import ReactDOM from 'react-dom'
import { document } from 'browser-monads'

// Use a ternary operator to make sure that the document object is defined
const portalRoot = document.getElementById('portal')

export default class Portal extends Component {

  constructor() {
    super()
    // Use a ternary operator to make sure that the document object is defined
    this.el = document.createElement('div') 
  }

  componentDidMount = () => {
    portalRoot.appendChild(this.el)
  }

  componentWillUnmount = () => {
    portalRoot.removeChild(this.el)
  }

  render() {
    const { children } = this.props

    // Check that this.el is not null before using ReactDOM.createPortal
    if (this.el) {
      return ReactDOM.createPortal(children, this.el)
    } else {
      return null
    }

  }
}

/* 
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { document } from 'browser-monads'


// https://levelup.gitconnected.com/accessible-modals-in-gatsby-using-portals-1e80e33a8a2

const portalRoot = document.getElementById('portal')

const Portal = ({ children }) => {

  const el = document.createElement('div')

  //useEffect(() => portalRoot.appendChild(el), []);

  useEffect(() => {
    portalRoot.appendChild(el)
  
    // returned function will be called on component unmount 
    return () => {
      portalRoot.removeChild(this.el)
    }
  }, [])

  return (
    if (this.el) {
      return ReactDOM.createPortal(children, this.el)
    } else {
      return null
    }
  )
}
 */

